const CLAIM_DETAILS_ACTION_TYPES = {
  CLAIM_DETAILS: 'CLAIM_DETAILS',
  SET_CLAIM_DATA: 'SET_CLAIM_DATA',
  RELOAD_CURRENT_PAGE: 'RELOAD_CURRENT_PAGE',
  VERIFY_CLAIM: 'VERIFY_CLAIM',
  RE_SUBMIT: 'RE_SUBMIT',
  SET_CLAIM_MANDATORY_CLASSIFICATION: 'SET_CLAIM_MANDATORY_CLASSIFICATION',
  SET_IS_CASHLESS_SUBMIT : 'SET_IS_CASHLESS_SUBMIT',
  SET_LINK_ABHA_CLICK: 'SET_LINK_ABHA_CLICK',
  SET_INPATIENT_RECONSIDER_ACTION: 'SET_INPATIENT_RECONSIDER_ACTION',
  SET_SINCE_YEAR_DATE : 'SET_SINCE_YEAR_DATE',
  CLAIM_DETAILS_PAYER_TYPE: 'CLAIM_DETAILS_PAYER_TYPE',
  SET_LINK_MORE_DOCS_TO_ABHA: 'SET_LINK_MORE_DOCS_TO_ABHA',
  SET_LINKED_TO_ABHA: 'SET_LINKED_TO_ABHA',
  SET_REASON_FOR_CANCELLAION: 'SET_REASON_FOR_CANCELLAION',
  MANUAL_STATUS_SYNC: 'MANUAL_STATUS_SYNC',
  SHOW_CLAIM_DETAIL_DATA: 'SHOW_CLAIM_DETAIL_DATA',
  IS_CANCEL_CLICKED: 'IS_CANCEL_CLICKED',
  SET_TIMELINE_COLOR_CODE: 'SET_TIMELINE_COLOR_CODE',
  IS_DETAIL_MODAL: 'IS_DETAIL_MODAL',
  SET_ARTEMIS_CLAIM: 'SET_ARTEMIS_CLAIM',
};

export default CLAIM_DETAILS_ACTION_TYPES;
